import React, { createContext, useState } from "react";
import { debounce } from "../helpers";

export const LoaderContext = createContext({
  isLoading: false,
  onLoader: () => {},
  offLoader: () => {},
});

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onLoader = () => setIsLoading(true);
  const offLoader = debounce(() => setIsLoading(false), 1500);

  return (
    <LoaderContext.Provider value={{ isLoading, onLoader, offLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};
